import React from 'react'

import { Form, Col } from '_zari/core'

const CantidadCuotasFormGroup = ({ fIsSubmitting, onChange, value }) => {
  return (
    <Form.Group>
      <Form.Label text='CUOTAS' htmlFor='select-cantidadCuotas' md={12} />
      <Col md={12}>
        <Form.Select disabled={fIsSubmitting} id='select-cantidadCuotas' name='select-cantidadCuotas' onChange={onChange} value={value}>
          <option value=''>Seleccionar</option>
          <option value='1'>1</option>
          <option value='2'>2</option>
          <option value='3'>3</option>
          <option value='4'>4</option>
          <option value='5'>5</option>
          <option value='6'>6</option>
          <option value='7'>7</option>
          <option value='8'>8</option>
          <option value='9'>9</option>
          <option value='10'>10</option>
          <option value='11'>11</option>
          <option value='12'>12</option>
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CantidadCuotasFormGroup)
